import { Extension } from '@tiptap/react';

export const RichTextParagraphClass = Extension.create({
  name: 'paragraphClass',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph'],
        attributes: {
          // Some rich-text flows need a stable styling hook on a paragraph
          // without rewriting the document structure around it.
          class: {
            default: null,
            parseHTML: (element) => element.getAttribute('class'),
            renderHTML: (attributes) => {
              if (!attributes.class) {
                return {};
              }

              return {
                class: attributes.class,
              };
            },
          },
        },
      },
    ];
  },
});

export default RichTextParagraphClass;
